export const OCTOCAPTCHA_ORIGIN =
  process.env.NODE_ENV === 'development' ? 'http://octocaptcha.localhost' : 'https://octocaptcha.com'

export const OCTOCAPTCHA_TIMEOUT = 30000
